import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Toolbar from "@mui/material/Toolbar";
import { useTheme } from "@mui/material/styles";
import { useRouter } from "next/router";
import InputSelectLanguage from "../shared/form/inputs/input_select_language";

export default function Header() {
	/* ---------------------------------- HOOKS --------------------------------- */
	const router = useRouter();
	const theme = useTheme();

	return (
		<>
			<AppBar
				sx={{
					backgroundColor: "primary.dark",
					border: "0px",
					borderRadius: 0,
					py: 0.5,
				}}
				elevation={0}
			>
				<Toolbar
					sx={{
						border: "0px",
						borderRadius: 0,
						height: "100px",
					}}
				>
					<Grid container display="flex" alignItems="center">
						<Grid item xs={12} display="flex" justifyContent="space-around">
							<Link sx={{ cursor: "pointer" }} onClick={() => router.push("/")}>
								<Box
									component="img"
									src={
										theme.palette.mode
											? process.env.NEXT_PUBLIC_LOGO_DARK_URL
											: process.env.NEXT_PUBLIC_LOGO_LIGHT_URL
									}
									alt="Attuor logo"
									sx={{ width: 180 }}
								/>
							</Link>

							<Box display="flex" alignItems="center">
								<InputSelectLanguage sx={{ height: 50 }} />
							</Box>
						</Grid>
					</Grid>
				</Toolbar>
			</AppBar>
			<Toolbar />
		</>
	);
}
